<template>
  <page
    :custom-style="{
      backgroundColor: '#fff',
      minHeight: '100vh'
    }"
  >
    <maple-nav-bar
      v-if="!isMiniProgram"
      class="cms-nav-bar"
      left-arrow
      :safe-top-distance="statusBarHeight"
      :opacity-style="!isEmpty"
      :opacity="opacity"
      :title="pageTitle"
      :left-arrow-color="isEmpty ? '#444' : '#fff'"
      :background="background"
      :title-color="titleColor"
      @click-left="goBack"
    />

    <empty
      v-if="isEmpty && !isLoading"
      :desc="'暂无商品'"
      :type="1"
      :img="'Empty'"
      class="empty-box"
    ></empty>
    <template v-else>
      <div
        v-if="!isEmpty"
        ref="expandHeader"
        class="hot-sale-header"
        :style="{
          backgroundImage: 'url(' + headImg + ')'
        }"
      >
        <p class="header-content" :style="{ top: 44 + statusBarHeight + 'px' }">
          {{ pageTitle }}
        </p>
      </div>
      <div v-if="!isEmpty" class="rank-cotent">
        <div
          :class="{
            'expand-tab': true,
            fixed: isMiniProgram ? false : pageFixed
          }"
          :style="{
            top: isMiniProgram ? '0' : 44 + statusBarHeight + 'px'
          }"
        >
          <scroll-view class="feed-tab-scroll" scroll-x>
            <div
              v-for="(item, index) in classList"
              :key="index"
              :class="['demand-word', { active: index === classIndex }]"
              @click="changeTab(index)"
            >
              {{ item.class1Name }}
            </div>
          </scroll-view>
        </div>

        <template v-if="dataList.length">
          <div
            v-for="(good, skuIndex) in dataList"
            :key="skuIndex"
            class="good-item"
          >
            <component
              :is="getComponentType(good)"
              :key="good.skuBase.skuId"
              :sku-index="skuIndex"
              :sku="good"
              :router-name="'activityArea'"
              :report-modle="'activityArea'"
              :map-id="'activityAreaExpose'"
              :common-tracer-param="{
                str_sale_class1_id: activeClass1Id
              }"
              :rank="false"
            ></component>
          </div>
          <page-bottom use-logo></page-bottom>
        </template>
        <template v-else-if="!isLoading">
          <empty
            :desc="'暂无商品'"
            :type="1"
            :img="'Empty'"
            class="empty-box"
          ></empty>
        </template>
      </div>
    </template>

    <cart-float-window />
  </page>
</template>
<script>
import { miniProgramEnv } from '@/defines/environment'
import { API } from '@/api'
import ScrollView from '@/common/widget/ScrollView/index.vue'
import PageBottom from '@/common/widget/pageBottom'
import SkuSingle from '@/common/widgets/newGood/skuSingle'
import SkuMultiple from '@/common/widgets/newGood/skuMultiple'
import Empty from '@/common/layout/empty/index'
import CartFloatWindow from '@/common/widgets/cart_float_window'
import headBgImg from '@/images/goods_rank/activity_head.png'
export default {
  name: 'ActivityArea',
  components: {
    ScrollView,
    Empty,
    SkuSingle,
    SkuMultiple,
    CartFloatWindow,
    PageBottom
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.goodsRank()
    })
  },
  data() {
    return {
      dataList: [],
      isLoading: false,
      isMiniProgram: miniProgramEnv.isMiniProgram,
      headImg: headBgImg,
      pageTitle: '活动专区',
      classList: [],
      classIndex: 0,
      opacity: 1,
      background: 'transparent',
      titleColor: 'transparent',
      pageFixed: false,
      activeClass1Id: ''
    }
  },
  computed: {
    isEmpty() {
      return this.classList.length === 0
    }
  },
  // 监控路由状态的改变获取参数重载页面
  watch: {
    $route(to, from) {
      location.reload()
    }
  },
  methods: {
    getComponentType(good) {
      if (good.ssuList.length === 1) {
        return 'sku-single'
      } else {
        return 'sku-multiple'
      }
    },
    async goodsRank() {
      try {
        this.opacity = 1
        this.background = 'transparent'
        this.titleColor = 'transparent'
        const params = {
          moduleKey: 78
        }
        document.title = this.pageTitle
        const data = await API.similygoods.getGoodsInfoLocation(params)
        const resData = data?.[0] || {}
        this.classList = resData.rows || []
        this.$nextTick(() => {
          this.handleScroll()
        })
        this.classIndex = 0
        this.getDataList(this.classIndex)
      } catch (e) {
        this.isLoading = false
      }
    },

    changeTab(index) {
      if (this.classIndex === index) return
      this.classIndex = index
      const classItem = this.classList[index]
      this.$track(this.$trackMap.activityArea.clickTab, {
        str_sale_class1_id: classItem?.class1Id + ''
      })
      this.getDataList(index)
    },
    async getDataList(index) {
      this.$Loading()
      this.isLoading = true
      const classItem = this.classList[index]
      const params = {
        moduleKey: 79,
        class1Id: classItem?.class1Id
      }
      this.activeClass1Id = classItem?.class1Id + ''
      try {
        const classRes = await API.similygoods.getGoodsInfoLocation(params)
        const resData = classRes?.[0] || {}
        this.dataList = resData?.rows || []
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
      }
      this.$Loading.hide()
    },
    goBack() {
      this.$back()
    },
    handleScroll() {
      if (this.isEmpty || !this.$refs.expandHeader) return
      window.addEventListener('scroll', e => {
        const boundingTop = this.$refs.expandHeader?.getBoundingClientRect()
          ?.top
        const navBar = document.querySelector('.cms-nav-bar')
        const navBarHeight = navBar?.getBoundingClientRect?.()?.height || 0

        const topHeight = 172 - 12 - navBarHeight
        if (boundingTop < -60) {
          this.opacity = 1
          this.background = '#FF4252'
          this.titleColor = '#fff'
        } else {
          this.background = 'transparent'
          this.titleColor = 'transparent'
        }
        if (boundingTop < -topHeight) {
          this.pageFixed = true
        } else {
          this.pageFixed = false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.hot-sale-header {
  position: relative;

  height: 172px;

  color: #fff;
  background-size: 100% 100%;

  .header-content {
    position: absolute;
    top: 1.2rem;

    left: 0.46rem /* 23/50 */;

    @include flex-row-center;

    @include text(0.56rem /* 28/50 */, #ffe1bd, true);
  }
}
.rank-cotent {
  box-sizing: border-box;
  position: relative;
  top: -12px;
  .good-item {
    background-color: #fff;
    padding-bottom: 6px;
  }
  .empty-box {
    position: relative;
    top: 2.4rem; /* 120/50 */
    background-color: #fff;
  }
}
.expand-tab {
  position: sticky;
  left: 0;
  z-index: 9;
  background-color: transparent;
  &.fixed {
    background-color: #ff4252;
  }

  .feed-tab-scroll {
    writing-mode: initial !important;
    @include flex(row, flex-start, flex-start, nowrap);
    padding-left: 8px;
    padding-top: 8px;
    padding-bottom: 12px;
    background-image: url('../../images/goods_rank/activity_tab.png');
    background-size: 100% 45px;
    background-repeat: no-repeat;
    box-sizing: border-box;
  }

  .demand-word {
    width: max-content;
    height: 25px;
    box-sizing: border-box;
    flex: none;
    flex-shrink: 0;
    border-radius: 14px; /* 圆角大小 */
    margin-right: 12px;
    transition: all 0.3s;
    padding: 4px 12px;
    background: #fff;
    border-radius: 14px;
    @include text(12px, #262626);
    @include flex-row-center;
    &.active {
      background-color: #fc224d;
      color: #fff;
    }
  }
}

.cms-nav-bar {
  position: fixed;
  top: 0;
  z-index: $z-navigation-bar;

  width: 100vw;
}
</style>
